import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Products from '../components/Products';
import WhyChooseUs from '../components/WhyChooseUs';
import Applications from '../components/Applications';
import Clients from '../components/Clients';
import Gallery from '../components/Gallery';
import Testimonials from '../components/Testimonials';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import { useContent } from '../hooks/useContent';

const Home = () => {
  const { content, loading, error } = useContent();

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600 font-medium">Loading...</p>
        </div>
      </div>
    );
  }

  if (error || !content) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center px-4">
        <div className="text-center max-w-md">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Unable to load content</h2>
          <p className="text-gray-600 mb-4">Please refresh the page or contact support.</p>
          <button
            onClick={() => window.location.reload()}
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg"
          >
            Refresh
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Header settings={content.siteSettings} contactInfo={content.contactInfo} />
      <Hero data={content.hero} />
      <About data={content.about} />
      <Products products={content.products} />
      <Clients clients={content.clients || []} />
      <WhyChooseUs reasons={content.whyChooseUs} />
      <Gallery images={content.gallery || []} />
      <Applications applications={content.applications} />
      <Testimonials testimonials={content.testimonials} contactInfo={content.contactInfo} />
      <Contact data={content.contactInfo} />
      <Footer settings={content.siteSettings} contactInfo={content.contactInfo} footer={content.footer || {}} />
      <WhatsAppButton contactInfo={content.contactInfo} />
    </div>
  );
};

export default Home;
